export default {"src":"/_next/static/media/dependencies.758273d1.svg","height":554,"width":661,"blurWidth":0,"blurHeight":0};